<template>
  <div class="updata">
    <Header :index="'user'" style="position:fixed;top:0;" />
    <div class="updataUser scc-container">
      <div class="updataTitle">
        <img src="../assets/imgs/person.png" />
        <span>{{$t("message.positioninformation")}}</span>
        <div class="border-bottom"></div>
      </div>
      <el-form class="updataUserForm" ref="form" :model="form" label-width="120px">
        <el-form-item :label="$t('message.headportrait')">
          <div class="demo-image__error" style="display: flex">
            <el-form-item>
              <div style="display: flex" class="pcImg">
                <img alt class="uplodImg" :src="form.userLogo" />
                <single-upload
                  :targetId="$route.query.eid?$route.query.eid:''"
                  v-model="form.userLogo"
                  :imgs="imgs"
                  pathType="5"
                  fileTip="支持JPG、GIF、PNG等图片格式 推荐尺寸：180*180像素"
                  :title="$t('message.uploadheadportrait')"
                />
              </div>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item :label="$t('message.Name')">
          <el-input size="large" v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.Company')">
          <el-input v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.Position')">
          <el-input v-model="form.job"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.Mobile')">
          <el-input disabled class="updataInput" v-model="form.phone">
            <el-select
              disabled
              style="width: 130px"
              v-model="telephonecodeONe"
              slot="prepend"
              placeholder
            >
              <el-option label="+86" value="+86"></el-option>
              <el-option label="+852" value="+852"></el-option>
              <el-option label="+853" value="+853"></el-option>
              <el-option label="+886" value="+886"></el-option>
              <el-option label="+1" value="+1"></el-option>
              <el-option label="+44" value="+44"></el-option>
            </el-select>
          </el-input>
          <span
            @click="isEmail = false,dialogVisible2 = true"
            class="red-span"
          >{{$t("message.update")}}</span>
        </el-form-item>
        <el-form-item :label="$t('message.Email')">
          <el-input disabled class="updataInput" v-model="form.email"></el-input>
          <span
            class="red-span"
            @click="isEmail = true,dialogVisible2 = true"
          >{{$t("message.update")}}</span>
        </el-form-item>
        <el-form-item :label="$t('message.industry2')">
          <el-select
            style="width: 100%;"
            v-model="form.industry"
            :placeholder="$t('message.seselectyourindustry')"
          >
            <el-option :label="$t('message.option1')" value="医院及医疗服务机构"></el-option>
            <el-option :label="$t('message.option2')" value="医药医疗企业"></el-option>
            <el-option :label="$t('message.option3')" value="高校及研究机构"></el-option>
            <el-option :label="$t('message.option4')" value="投资及金融机构"></el-option>
            <el-option :label="$t('message.option5')" value="政府架构及学协会"></el-option>
            <el-option :label="$t('message.option6')" value="媒体"></el-option>
            <el-option :label="$t('message.option7')" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$t('message.Cardtoupload')">
          <div class="demo-image__error" style="display: flex">
            <el-form-item>
              <div style="display: flex" class="businesscard">
                <img alt class="uplodImg" :src="form.card" />
                <single-upload
                  :targetId="$route.query.eid?$route.query.eid:''"
                  v-model="form.card"
                  :imgs="imgs"
                  pathType="5"
                  fileTip="支持JPG、GIF、PNG等图片格式 推荐尺寸：180*180像素"
                  :title="$t('message.Uploadcard')"
                />
              </div>
            </el-form-item>
          </div>
        </el-form-item>-->
        <el-form-item :label="$t('message.Remark')">
          <el-input type="textarea" :rows="9" v-model="form.marks"></el-input>
        </el-form-item>
        <div style="display: flex;justify-content: center;">
          <el-button
            style="width: 170px;margin: 80px 0;"
            type="primary"
            round
            @click="submitForm('form')"
            size="medium"
          >{{$t("message.save")}}</el-button>
        </div>
      </el-form>
      <!-- 修改弹窗 -->
      <el-dialog
        :visible.sync="dialogVisible2"
        custom-class="updata-dialog"
        :close-on-click-modal="false"
        @open="updataPhone"
        @close="clearData"
      >
        <div class="pro-value">
          <div class="pro-item active">
            <div class="value">1</div>
            <span>{{$t("message.authentication")}}</span>
            <div class="border-center"></div>
          </div>
          <div class="pro-item" :class="active > 1?'active':''">
            <div class="value">2</div>
            <span>{{$t("message.Verifyyournewphoneoremailaddress")}}</span>
            <div class="border-center"></div>
          </div>
          <div class="pro-item" :class="active > 2?'active':''">
            <div class="value">3</div>
            <span>{{$t("message.finish")}}</span>
          </div>
        </div>
        <p v-if="active == 2" class="pro-text">{{$t("message.Identitypassed")}}</p>
        <el-form
          v-if="active !=3"
          ref="form2"
          label-position="top"
          :model="form2"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item prop="phone" :label="label1">
            <el-input :disabled="active == 1" v-model="form2.phone" :placeholder="label2">
              <el-select
                v-if="!isEmail"
                style="width: 130px"
                v-model="telephonecode"
                slot="prepend"
                placeholder
                :disabled="active == 1"
              >
                <el-option label="+86" value="+86"></el-option>
                <el-option label="+852" value="+852"></el-option>
                <el-option label="+853" value="+853"></el-option>
                <el-option label="+886" value="+886"></el-option>
                <el-option label="+1" value="+1"></el-option>
                <el-option label="+44" value="+44"></el-option>
              </el-select>
              <el-button
                :disabled="isok"
                v-show="isGetCode"
                @click="getCode('form2')"
                type="primary"
                slot="append"
              >{{$t(mes)}}</el-button>
              <div v-show="iscaptcha" slot="append" id="captcha"></div>
            </el-input>
          </el-form-item>
          <el-form-item prop="code" :label="$t('message.Enter code')">
            <el-input v-model="form2.code" :placeholder="$t('message.codeTips')"></el-input>
          </el-form-item>
        </el-form>
        <div v-if="active == 3" class="updata-suceess">
          <i class="check-true el-icon-circle-check"></i>
          <p class="text-onde">{{$t("message.congratulations")}}</p>
          <p class="text-updata">{{$t("message.modifysuccessfully")}}</p>
        </div>
        <div style="display: flex;justify-content: center;margin-top: 40px">
          <el-button
            v-if="active < 3"
            type="primary"
            round
            @click="submitForm2('form2')"
            style="width: 225px;
    height: 48px;
    border-radius: 24px;"
          >{{$t("message.Next")}}</el-button>
          <el-button
            @click="finish"
            v-else
            type="primary"
            round
            style="width: 225px;
    height: 48px;
    border-radius: 24px;"
          >{{$t("message.finish")}}</el-button>
        </div>
      </el-dialog>
    </div>
    <Footer />
  </div>
</template>
<script>
import { callApi } from "../api/callApi";
// import apiMethod from "../global/config";
import { setToken } from "../utils/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
// import { apiMethod } from "../global/config";
import { Message } from "element-ui";
import {
  apiMethod,
  pushLog,
  logProdType,
  targetType,
  eventType,
  pageType
} from "../global/config";
export default {
  components: {
    Header,
    Footer
  },
  name: "Dashboard",
  data() {
    let validatephone = (rule, value, callback) => {
      if (value === "") {
        !this.isEmail
          ? callback(new Error(this.$t("message.PleaseenteryourEmail")))
          : callback(new Error(this.$t("message.enteryourEmail")));
      } else if (
        this.isEmail &&
        !/^([A-Za-z0-9]+)(([A-Za-z0-9]+)|(_+)|(\-+)|(\.+)|(\++))*@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,8}$/.test(
          value
        )
      ) {
        callback(new Error(this.$t("message.trueEmail")));
      } else {
        callback();
      }
    };
    let validatepassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("message.eceived")));
      } else {
        callback();
      }
    };
    return {
      isok: false,
      isGetCode: true,
      iscaptcha: true,
      mes: "message.code",
      rules: {
        phone: [{ required: true, validator: validatephone, trigger: "blur" }],
        code: [
          {
            required: true,
            validator: validatepassword,
            trigger: "blur"
          }
        ]
      },
      isEmail: false,
      telephonecodeONe: "",
      active: 1,
      phone: "",
      code: "",
      select: "",
      file: "",
      dialogVisible2: false,
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      dialogVisible: false,
      value: "",
      value1: "",
      telephonecode: "",
      form2: {
        phone: "",
        code: "",
        type: 1
      },
      form: {
        card: "",
        company: "",
        email: "",
        industry: "",
        job: "",
        marks: "",
        phone: "",
        userLogo: "",
        userName: ""
      },
      timer: null
    };
  },
  watch: {
    "$i18n.locale"(newval, oldval) {
      if (this.$refs["form2"]) {
        this.$refs["form2"].fields.forEach(item => {
          if (item.validateState === "error") {
            this.$refs["form2"].validateField(item.labelFor);
          }
        });
      }
    }
  },
  computed: {
    label1() {
      if (this.active == 1) {
        if (!this.isEmail) {
          return this.$t("message.phone");
        } else {
          return this.$t("message.Email");
        }
      } else {
        if (!this.isEmail) {
          return this.$t("message.newphone");
        } else {
          return this.$t("message.newemail");
        }
      }
    },
    label2() {
      if (this.active == 1) {
        if (!this.isEmail) {
          return this.$t("message.Pleaseenteryourphone");
        } else {
          return this.$t("message.enteryourEmail");
        }
      } else {
        if (!this.isEmail) {
          return this.$t("message.Pleaseenteryournewphone");
        } else {
          return this.$t("message.enteryournewEmail");
        }
      }
    }
  },
  methods: {
    clearData() {
      this.isEmail = false;
      this.active = 1;
      clearInterval(this.timer);
      this.timer = null;
      this.mes = "message.code";
      if(this.$refs.form2){
        this.$refs.form2.clearValidate();
      }; 
      this.isok = false;
      this.form2 = {
        phone: "",
        code: "",
        type: 1
      };
    },
    updataPhone() {
      if (this.isEmail) {
        this.active = 2;
        // if (this.form.email) {
        //   this.form2.phone = this.form.email;
        // }
      } else {
        if (this.form.phone) {
          this.form2.phone = this.form.phone;
        }
      }
    },
    finish() {
      this.dialogVisible2 = false;
    },
    close() {
      this.$emit("close");
    },
    change() {
      this.$i18n.locale = "en";
      window.localStorage.setItem("qinLang", "en");
      console.log(2);
    },
    countdown() {
      // this.isclick = false;
      this.isok = true;
      let num = 60;
      this.timer = setInterval(() => {
        this.mes = num + "s";
        num--;
        if (num < 0) {
          clearInterval(this.timer);
          this.mes = "message.code";
          this.isok = false;
        }
      }, 1000);
    },
    resCode(res) {
      if (res.code == 600) {
        this.iscaptcha = true;
        this.isGetCode = false;
        nvcReset();
        getNC().then(function() {
          _nvc_nc.upLang("cn", {
            _startTEXT: "请按住滑块，拖动到最右边",
            _yesTEXT: "验证通过",
            _error300:
              '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
            _errorNetwork:
              '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
          });
          _nvc_nc.reset();
        });
      }
      if (res.code == 400) {
        this.iscaptcha = true;
        this.isGetCode = false;
        getNC().then(function() {
          _nvc_nc.upLang("cn", {
            _startTEXT: "请按住滑块，拖动到最右边",
            _yesTEXT: "验证通过",
            _error300:
              '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
            _errorNetwork:
              '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
          });
          _nvc_nc.reset();
        });
      }
      if (res.code == 700) {
        this.iscaptcha = true;
        this.isGetCode = false;
        getNC().then(function() {
          _nvc_nc.upLang("cn", {
            _startTEXT: "请按住滑块，拖动到最右边",
            _yesTEXT: "验证通过",
            _error300:
              '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
            _errorNetwork:
              '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
          });
          _nvc_nc.reset();
        });
      }
      if (res.code == 900) {
        this.iscaptcha = true;
        this.isGetCode = false;
        getNC().then(function() {
          _nvc_nc.upLang("cn", {
            _startTEXT: "请按住滑块，拖动到最右边",
            _yesTEXT: "验证通过",
            _error300:
              '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
            _errorNetwork:
              '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
          });
          _nvc_nc.reset();
        });
      }
      if (res.code == 800) {
        nvcReset();
        Message({
          message:
            this.$i18n.locale == "zh"
              ? res.message.split("/")[0]
              : res.message.split("/")[1],
          type: "error",
          duration: 3 * 1000
          // this.getCode2('form2')
        });
      }
      if (res.code == 501) {
        Message({
          message:
            this.$i18n.locale == "zh"
              ? res.message.split("/")[0]
              : res.message.split("/")[1],
          type: "error",
          duration: 3 * 1000
        });
      }
    },
    getCode(formName) {
      this.$refs[formName].validateField("phone", errMsg => {
        if (!errMsg) {
          this.isGetCode = true;
          this.iscaptcha = false;
          if (this.active == 2 && this.form2.phone == this.form.phone) {
            this.$message({
              message: "请输入新的手机号",
              type: "error"
            });
          } else {
            let data = {
              emailOrPhone: this.isEmail
                ? this.form2.phone
                : this.telephonecode + "-" + this.form2.phone,
              useWay: 2,
              a: getNVCVal()
            };
            callApi(apiMethod.verification, data)
              .then(res => {
                this.resCode(res);
                if (res.code == 200) {
                  this.isGetCode = true;
                  this.iscaptcha = false;
                  this.$message({
                    message:
                      this.$i18n.locale == "zh"
                        ? res.message.split("/")[0]
                        : res.message.split("/")[1],
                    type: "success"
                  });
                  this.countdown();
                } else if (res.code == 500) {
                  this.$message({
                    message:
                      this.$i18n.locale == "zh"
                        ? res.message.split("/")[0]
                        : res.message.split("/")[1],
                    type: "success"
                  });
                }
              })
              .catch(errMsg => {});
          }
        } else {
          this.$message({
            message: this.$t("message.Pleasefill"),
            type: "error"
          });
          return false;
        }
      });
    },
    imgs(val) {
      this.file = val;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {
            card: this.form.card,
            company: this.form.company,
            email: this.form.email,
            industry: this.form.industry,
            job: this.form.job,
            marks: this.form.marks,
            phone: this.telephonecodeONe + "-" + this.form.phone,
            userLogo: this.form.userLogo,
            userName: this.form.userName
          };
          this.$c(this.$g.UPDATA_USER_INFO, data).then(res => {
            if (res.code == 200) {
              this.$c(this.$g.USER_GET_INFO).then(res => {
                console.log(res.data.userName);
                if (res.code === 200 && res.success) {
                  localStorage.setItem("myName", res.data.userName);
                  this.$store.dispatch("setName", res.data.userName);
                }
              });
              this.$message({
                message:
                  this.$i18n.locale == "zh"
                    ? res.message.split("/")[0]
                    : res.message.split("/")[1],
                type: "success"
              });
            }
          });
        } else {
          this.$message({
            message: this.$t("message.Pleasefill"),
            type: "error"
          });
          return false;
        }
      });
    },
    submitForm2(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$c(this.$g.CHECK_CODE, {
            code: this.form2.code,
            emailOrPhone: this.isEmail
              ? this.form2.phone
              : this.telephonecode + "-" + this.form2.phone
          })
            .then(res => {
              if (res.code == 200) {
                clearInterval(this.timer);
                this.timer = null;
                this.mes = "message.code";
                this.isok = false;
                if (this.active == 2) {
                  this.$c(this.$g.updatePhoneOrEmail, {
                    code: this.form2.code,
                    emailOrPhone: this.isEmail
                      ? this.form2.phone
                      : this.telephonecode + "-" + this.form2.phone
                  }).then(res => {
                    if (res.code == 200) {
                      if (this.isEmail) {
                        this.form.email = res.data;
                      } else {
                        this.telephonecodeONe = res.data.split("-")[0];
                        this.form.phone = res.data.split("-")[1];
                      }
                    }
                  });
                }
                this.active++;
                this.form2.phone = "";
                this.telephonecode = "+86";
                this.form2.code = "";
              } else {
                Message({
                  message:
                    this.$i18n.locale == "zh"
                      ? res.message.split("/")[0]
                      : res.message.split("/")[1],
                  type: "error",
                  duration: 3 * 1000
                });
              }
            })
            .catch(err => {
              if (err) {
                // this.$message({
                //     message: "验证码不正确",
                //     type: "error"
                // });
              }
            });
        } else {
          this.$message({
            message: this.$t("message.Pleasefill"),
            type: "error"
          });
          return false;
        }
      });
    },
    async getData() {
      // 回填数据
      // const newObj = JSON.parse(this.$route.query.data)
      // Object.assign(this.form, newObj);
    },
    beforeunloadFn(e) {
      console.log("关闭");
      pushLog(
        this,
        logProdType.PC,
        pageType.LIVE,
        eventType.PAGE_CLOSE,
        targetType.PAGE,
        "/updata"
      );
    },
    beforeloadFn(e) {
      console.log("刷新");
      pushLog(
        this,
        logProdType.PC,
        pageType.LIVE,
        eventType.PAGE_LOAD,
        targetType.PAGE,
        "/updata"
      );
    }
  },
  created() {
    this.$c(this.$g.USER_GET_INFO).then(res => {
      if (res.code === 200 && res.success) {
        console.log(res.data);
        Object.assign(this.form, res.data);
        this.telephonecodeONe = this.form.phone.split("-")[0];
        this.telephonecode = this.form.phone.split("-")[0];
        this.form.phone = this.form.phone.split("-")[1];
        // this.form2.phone = this.form.phone;
        console.log(this.telephonecodeONe, this.form);
      }
    });
  },
  mounted() {
    // this.getData();
    this.beforeloadFn();
    this.$ba.trackPageview("/updata");
  },
  destroyed() {
    this.beforeunloadFn();
  }
};
</script>
<style lang="less">
@import "@/style/variable.less";
.updataUserForm {
  .el-form-item__label {
    text-align: left;
  }
}

.updata-dialog {
  width: 1080px;
  box-sizing: border-box;

  .el-dialog__headerbtn {
    width: 56px;
    height: 61px;
    background: url("../assets/imgs/guanbi-2.png") top right no-repeat;
    background-size: 99%;
    top: 0;
    right: -1px;
  }

  .el-dialog__close {
    &:before {
      content: "";
    }
  }

  .el-dialog__body {
    padding: 40px 140px 40px 140px;

    .el-form-item__label {
      font-size: 15px;
      font-family: Alibaba PuHuiTi;
      /*font-weight: bold;*/
      color: rgba(33, 33, 33, 1);
    }

    .el-input__inner {
      height: 42px;
    }

    .el-input-group__append {
      width: 130px;
      background: @color;
      border-radius: 0px 8px 8px 0px;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
    }
  }
}
.updataUser {
  .el-button--primary {
    background-color: @color;
    border-color: @color;
  }
  .el-select {
    .el-input {
      .el-select__caret {
        color: @color;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import "@/style/variable.less";
.pro-value {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  .pro-item {
    &.active {
      .value {
        background: @color;
      }
    }
    span {
      font-size: 15px;
    }
    font-size: 18px;
    color: rgba(32, 32, 32, 1);
    font-weight: 500;
    display: flex;
    align-items: center;

    .value {
      width: 37px;
      height: 37px;
      background: rgba(201, 201, 201, 1);
      border-radius: 50%;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 40px;
      margin-right: 16px;
    }

    .border-center {
      width: 45px;
      border-bottom: 1px solid rgba(95, 95, 95, 1);
      margin: 0 13px 0 14px;
    }
  }
}

.pro-text {
  font-size: 20px;
  color: rgba(98, 98, 98, 1);
  text-align: center;
  margin-bottom: 20px;
}

.updata-suceess {
  text-align: center;

  .check-true {
    font-size: 92px;
    color: @color;
  }

  .text-onde {
    color: rgba(34, 34, 34, 1);
    font-size: 30px;
    margin: 34px 0 31px 0;
  }

  .text-updata {
    font-size: 20px;
    color: rgba(170, 170, 170, 1);
  }
}

.scc-container {
  width: 1080px;
  margin: 0 auto;

  .updataTitle {
    margin-top: 200px;
    color: rgba(34, 34, 34, 1);
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 26px;
    border-bottom: 1px solid rgba(169, 196, 242, 1);
    position: relative;

    img {
      vertical-align: middle;
      margin-right: 16px;
      display: inline-block;
    }

    span {
      vertical-align: middle;
    }

    .border-bottom {
      position: absolute;
      left: 0;
      bottom: -3px;
      height: 3px;
      background: @color;
      width: 368px;
    }
  }

  .updataUserForm {
    padding: 40px 120px 0px 120px;

    .uplodImg {
      /*border:1px solid rgba(201,201,201,1);*/
      border: 1px solid #dcdfe6;
      border-radius: 8px;
    }

    .updataInput {
      width: calc(100% - 100px);
    }
  }
}

.gl-container {
  padding-right: 250px;
}

.red-span {
  color: @color;
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
  width: 100px;
  text-align: center;
}

.pcImg {
  img {
    width: 135px;
    height: 135px;
  }

  .el-image {
    width: 204px;
    height: 192px;
  }
}

.businesscard {
  img {
    width: 323px;
    height: 150px;
  }

  .el-image {
    width: 367px;
    height: 198px;
  }
}

.guestList {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .guestListItem {
    height: 120px;
    width: 110px;
    border: 1px solid rgb(224, 224, 224);
    border-radius: 5px;
    position: relative;
  }

  .guestListIMG {
    margin-right: 10px;

    .guestListIMGContent {
      :hover {
        opacity: 0.2;
      }
    }

    .guestListIMGIco {
      position: absolute;
      top: 8px;
      right: 8px;
      cursor: pointer;
    }
  }

  .guestListItemAdd {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .guestListItemAddIco {
      display: flex;
      height: 20px;
      width: 20px;
      border: 2px solid red;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      color: red;
      font-weight: bold;
    }
  }
}

/deep/ .image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 19px;
  background: #cccccc;
}

/deep/ .upload-demo {
  padding-left: 30px;
}

.top {
  text-align: center;
  height: 100px;
  line-height: 100px;
  font-size: 24px;
  /*font-weight: 700;*/
}

.desc {
  font-weight: 700;
  color: #2271ff;
}

.input {
  height: 64px;
  font-size: 20px;
  border: 1px solid rgba(201, 201, 201, 1);
  border-radius: 8px 0 0 8px;
  padding: 0 30px;
}

.input1 {
  height: 64px;
  border: 1px solid rgba(201, 201, 201, 1);
  border-radius: 8px;
  font-size: 20px;
  padding: 0 30px;
}

.getcode {
  display: inline-block;
  width: 170px;
  height: 67px;
  line-height: 64px;
  text-align: center;
  background: @color;
  border-radius: 0px 8px 8px 0px;
  color: #fff;
  cursor: pointer;
}

.dobut {
  width: 900px;
  height: 15px;
  text-align: right;
  margin-left: 190px;
  margin-top: 10px;
  color: #2271ff;
  margin-bottom: 40px;
}

.commit {
  width: 300px;
  height: 64px;
  text-align: center;
  line-height: 64px;
  background: @color;
  border-radius: 32px;
  color: #fff;
  margin: 20px auto;
}
</style>





